import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/constants";

export const Testimonials = () => {
    return (
        <section
            id="depoimentos"
            data-testid="testimonials-section"
            className="bg-white py-20 md:py-28"
        >
            <div className="container mx-auto px-4 md:px-8">
                <div className="max-w-3xl mb-12 md:mb-16">
                    <span className="text-xs font-bold tracking-[0.3em] uppercase text-[#f45100]">
                        · Quem já chamou recomenda ·
                    </span>
                    <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tight text-black mt-3 leading-[0.95]">
                        Histórias reais de quem foi{" "}
                        <span className="text-[#f45100]">socorrido</span> pela
                        RCM.
                    </h2>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                    {TESTIMONIALS.map((t, i) => (
                        <article
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className="group relative p-7 md:p-8 bg-[#f8f9fa] border border-gray-200 hover:border-[#f45100] hover:bg-white hover:shadow-2xl hover:shadow-black/5 hover:-translate-y-1 transition-all duration-300"
                        >
                            <Quote
                                size={32}
                                className="text-[#f45100] mb-4"
                                strokeWidth={2.5}
                            />
                            <p className="text-black text-[15px] leading-relaxed font-medium">
                                "{t.text}"
                            </p>

                            <div className="mt-6 pt-5 border-t border-gray-200 flex items-center justify-between">
                                <div>
                                    <div className="font-display text-base font-extrabold tracking-tight text-black">
                                        {t.name}
                                    </div>
                                    <div className="text-xs text-gray-500 mt-0.5">
                                        {t.location}
                                    </div>
                                </div>
                                <div className="text-right">
                                    <div className="flex gap-0.5 text-[#f45100] text-sm">
                                        {[...Array(t.rating)].map((_, i) => (
                                            <span key={i}>★</span>
                                        ))}
                                    </div>
                                    <div className="text-[10px] text-gray-500 uppercase tracking-wider mt-1">
                                        {t.service}
                                    </div>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
